/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EventManagementCreateEventItemRequest = {
    id?: number;
    eventId?: number;
    code: string;
    producer: string;
    producerEn?: string;
    producerCn?: string;
    kind?: string;
    kindEn?: string;
    kindCn?: string;
    ageId?: number;
    sex: EventManagementCreateEventItemRequest.sex;
    size?: number;
    parent?: string;
    parentEn?: string;
    parentCn?: string;
    price: number;
    isBidding: boolean;
    note?: string;
    noteEn?: string;
    noteCn?: string;
    status: EventManagementCreateEventItemRequest.status;
};

export namespace EventManagementCreateEventItemRequest {

    export enum sex {
        MALE = 'male',
        FEMALE = 'female',
        UNKNOWN = 'unknown',
        FEMALE_NOW = 'female_now',
    }

    export enum status {
        RELEASE = 'release',
        SOLDOUT = 'soldout',
        CANCEL = 'cancel',
    }


}

